import { dispatcher, services } from '@ambita/ambita-components-core';
import { generateCadastreLookupFromQuery } from '../dataServices/cadastreReport';
import * as cadastreReportConstants from '../constants/cadastreReport';

const { log } = services;
const { actions: cadastreReportActions } = cadastreReportConstants;

const storeCadastreLookup = (data: string): void => {
  dispatcher.dispatch({
    actionType: cadastreReportActions.STORE_CADASTRE_LOOKUP,
    data
  });
};

const storeCadastreLookupError = (error: string): void => {
  dispatcher.dispatch({
    actionType: cadastreReportActions.STORE_CADASTRE_LOOKUP_ERROR,
    error
  });
};

const cadastreLookupLoading = (): void => {
  dispatcher.dispatch({
    actionType: cadastreReportActions.CADASTRE_LOOKUP_LOADING
  });
};

export const requestCadastreLookup = (cadastreId: string): void => {
  const query: any = { cadastre: cadastreId };
  cadastreLookupLoading();
  generateCadastreLookupFromQuery(query)
    .then(cadastreLookup => {
      if (cadastreLookup) {
        storeCadastreLookup(cadastreLookup);
      }
    })
    .catch(error => {
      storeCadastreLookupError(error);
      log.error('Loading of cadastreLookup failed. Cause:', error);
    });
};
